<template>
    <div style="display: flex; align-items: center; justify-content: center; margin-left: 10px; margin-right: 4px;">
        
    </div>

    <div style="margin-left: 6px; margin-right: 12px; min-width: 0px; flex: 1 1 auto;">
        <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">Het Tarkhala</div>
    </div>
</template>